import React from 'react';
import { AlertTriangle, RefreshCw, ExternalLink } from 'lucide-react';

const EmbeddedOnboardingFallback = ({ 
    error, 
    onRetry, 
    onFallbackToRedirect, 
    loading = false 
}) => {
    return (
        <div className="embedded-fallback">
            <div className="embedded-fallback__content">
                <div className="error-icon">
                    <AlertTriangle size={48} />
                </div>
                
                <h3>Unable to Load Embedded Setup</h3>
                <p>
                    We encountered an issue loading the embedded onboarding form. 
                    This could be due to network connectivity or configuration issues.
                </p>
                
                {error && (
                    <div className="error-details">
                        <strong>Error Details:</strong>
                        <code>{error.message || 'Unknown error occurred'}</code>
                    </div>
                )}
                
                <div className="fallback-options">
                    <button 
                        type="button" 
                        className="btn-secondary"
                        onClick={onRetry}
                        disabled={loading}
                    >
                        <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
                        Try Again
                    </button>
                    
                    <button 
                        type="button" 
                        className="btn-primary"
                        onClick={onFallbackToRedirect}
                        disabled={loading}
                    >
                        <ExternalLink size={16} />
                        Continue with Redirect Setup
                    </button>
                </div>
                
                <div className="fallback-note">
                    <p>
                        The redirect setup will open Stripe's secure onboarding page in a new window. 
                        You'll be redirected back here once complete.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EmbeddedOnboardingFallback;